import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var UpdatedByService = /** @class */ (function () {
    function UpdatedByService(translateService) {
        this.translateService = translateService;
        this.customAuthorDeviceMapper = Object.freeze({
            mountdoom: 'laptop',
            lorgan: 'upload',
            gorgoroth: 'smartphone',
            system: 'settings'
        });
    }
    UpdatedByService.prototype.customUpdatedByIn = function (equipmentMaintenances) {
        var e_1, _a;
        try {
            for (var equipmentMaintenances_1 = tslib_1.__values(equipmentMaintenances), equipmentMaintenances_1_1 = equipmentMaintenances_1.next(); !equipmentMaintenances_1_1.done; equipmentMaintenances_1_1 = equipmentMaintenances_1.next()) {
                var equipmentMaintenance = equipmentMaintenances_1_1.value;
                equipmentMaintenance = this.generateUpdateBy(equipmentMaintenance);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (equipmentMaintenances_1_1 && !equipmentMaintenances_1_1.done && (_a = equipmentMaintenances_1.return)) _a.call(equipmentMaintenances_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return equipmentMaintenances;
    };
    UpdatedByService.prototype.generateUpdateBy = function (equipmentMaintenance) {
        var equipmentMaintenanceLog = equipmentMaintenance.log || {};
        var logCustomAuthor = {
            type: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.CREATED'),
            updatedByName: null,
            clientApplicationName: this.translateService.instant("MAINTENANCES.TABS.LOGS.PLATFORMS." + String(equipmentMaintenanceLog.clientApplicationName || 'BROWSER').toUpperCase())
        };
        if (equipmentMaintenanceLog.updatedBy && equipmentMaintenanceLog.updatedBy.name) {
            logCustomAuthor.updatedByName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.BY_AUTHOR', {
                authorName: equipmentMaintenanceLog.updatedBy.name
            });
        }
        if (equipmentMaintenanceLog.clientApplicationName) {
            logCustomAuthor.clientApplicationName = this.translateService.instant("EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.DEVICES." + String(equipmentMaintenanceLog.clientApplicationName).toUpperCase());
        }
        if (Object.values(logCustomAuthor).filter(Boolean).length >= 2) {
            equipmentMaintenance.customAuthorDevice = this.customAuthorDeviceMapper[equipmentMaintenanceLog.clientApplicationName];
            equipmentMaintenance.customAuthor = Object.values(logCustomAuthor).filter(Boolean).join(' ');
        }
        return equipmentMaintenance;
    };
    UpdatedByService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UpdatedByService_Factory() { return new UpdatedByService(i0.ɵɵinject(i1.TranslateService)); }, token: UpdatedByService, providedIn: "root" });
    return UpdatedByService;
}());
export { UpdatedByService };
